import { useEffect, useState, useRef } from 'react';
import {
  database,
  ref,
  set,
  onValue,
  off,
  remove,
  onDisconnect
} from '../lib/firebase';

// Writes this tab's presence entry to Firebase. Must only be called once
// per app instance — calling it from multiple components causes a single
// user to be counted multiple times.
export function usePresence() {
  const playerId = useRef<string>(Math.random().toString(36).substring(7));

  useEffect(() => {
    const id = playerId.current;
    const connectedRef = ref(database, '.info/connected');

    onValue(connectedRef, (snapshot) => {
      if (snapshot.val() === true) {
        const presenceRef = ref(database, `presence/${id}`);
        set(presenceRef, { online: true, timestamp: Date.now() });
        onDisconnect(presenceRef).remove();
      }
    });

    return () => {
      off(connectedRef);
      remove(ref(database, `presence/${id}`));
    };
  }, []);
}

// Read-only: returns connection state and the current online-player count.
// Safe to call from multiple components.
export function useOnlinePlayers() {
  const [onlinePlayers, setOnlinePlayers] = useState(0);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const connectedRef = ref(database, '.info/connected');
    onValue(connectedRef, (snapshot) => {
      setIsConnected(snapshot.val() === true);
    });

    const allPresenceRef = ref(database, 'presence');
    onValue(allPresenceRef, (snapshot) => {
      const count = snapshot.exists() ? Object.keys(snapshot.val()).length : 0;
      setOnlinePlayers(count);
    });

    return () => {
      off(connectedRef);
      off(allPresenceRef);
    };
  }, []);

  return { onlinePlayers, isConnected };
}
